<template>
  <router-view/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalBus from '../../event-bus/modal-bus';
import SubscriptionCtaPopup from '../../pages/responsive-pages/authenticated/trial/SubscriptionCtaPopup.vue';

export default {
  name: 'PoupupManager',
  props: {
    hideCta: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    if (this.shouldShowCta && !this.hideCta) {
      ModalBus.$emit('open', {
        component: SubscriptionCtaPopup,
      });
    }
  },
  computed: {
    ...mapGetters('subscriptionState', ['shouldShowCta']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
  },
};
</script>
